import React, { useContext, useRef, useState } from 'react'
import AudioComponent from '../commonComponents/AudioComponent';
import { Context } from '../context/Context';
import listeningMusic from '../assets/green/listening_music_white_bg.png'
import musicPlay from "../assets/green/play2.png";
import musicPause from "../assets/green/pause2.png";
import { useLocation } from 'react-router-dom';

function Audios() {
  const { lang, theme } = useContext(Context);
  const audioRef = useRef(null);
  const location = useLocation();
  const data =  location.state.audioData
const [isPlaying, setIsPlaying] = useState(false)
const [songIndex , setSongIndex] = useState(0);
const [currentAudio, setCurrentAudio] = useState()
const [refSave , setRefSave] = useState(null)



const refHandler = ( ref ) => {
  console.log("ref received in refHandler", ref.current);

  if(!refSave){
    setRefSave(ref)
    console.log("refSave.current in if", ref.current)

  }else{
    refSave.current.pause()
    // setRefSave(null)
    setRefSave(ref)
    console.log("refSave.current in else", ref.current)
  }

}


  const onClickHandler = (index , data) => {
    setCurrentAudio(data)

    if (isPlaying) {
      setIsPlaying(!isPlaying);
      setTimeout(() => audioRef.current.pause(), 100);
  }else {
      setIsPlaying(true);
      setTimeout(() => audioRef.current.play(), 100);
    }

  };







  return (
    <div className={` h-[100vh] absolute pt-20 bg-green max-w-[500px] w-full bg-center bg-cover text-black ${theme === "red" ? "bg-red_bg_pic" : "bg-green_bg_pic"}`}>
      <div className=''>
        <div className='w-[50%] flex justify-center mx-auto '>
          <div className={`${theme === "red" ? "bg-red_surah_name_board " : "bg-surah_name_board "} bg-contain flex items-center justify-center pb-2 text-white font-bold bg-no-repeat w-[85%] h-12`}>{data?.ramadanCategory}</div>
        </div>
      </div>

      <div className='px-8'>

        {
          data?.data?.map((data, index) => {
            return  <AudioComponent name={data?.name} link={data?.link} refHandler={refHandler} parentRef={refSave}/>
          })
        }



      </div>



    </div>


  )
}

export default Audios